import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'unistore/react';
import classnames from 'classnames';
import * as D3dsv from 'd3-dsv';

import actions from '~/scripts/state/actions';
import PartyBars from '~/scripts/PartyBars';
import RankingList from '~/scripts/RankingList';
import RankingListExpandButton from '~/scripts/RankingList/ExpandButton';
import analysisConfig from '~/scripts/Analysis/config';

class OverallResult extends PureComponent {
  static propTypes = {
    isCompact: PropTypes.bool
  };

  static defaultProps = {
    isCompact: false
  };

  state = {
    isExpanded: false
  };

  componentDidMount() {
    const wrapper = document.querySelector('.electionmap-wrapper');

    this.wrapperBounds = wrapper.getBoundingClientRect();
    this.maxHeight = this.props.isCompact
      ? 'none'
      : `${this.wrapperBounds.height * 0.65 - 120}px`;
  }

  onToggleExpand() {
    this.setState(prevState => ({ isExpanded: !prevState.isExpanded }));
  }

  setParty(partyName) {
    if (partyName === 'sonstige') {
      return false;
    }
    const matchingAnalysis = analysisConfig.find(a => a.map === partyName);

    if (matchingAnalysis) {
      return this.props.setAnalysis(matchingAnalysis);
    }

    this.props.setParty(partyName);
  }

  render() {
    const { isCompact, data, turnout } = this.props;
    const { isExpanded } = this.state;
    const showRanking = isExpanded && !isCompact;
    const wrapperClasses = classnames('overallresult', {
      'is-compact': isCompact
    });

    if (!this.props.data || !this.props.data.length) {
      return null;
    }
    
    return (
      <div className={wrapperClasses}>
        <div className="overallresult__inner">
          <div className="overallresult__title">
            So hat NRW gewählt
          </div>
          <div className="overallresult__legend">
    <div className="overallresult__legend-item now">Gesamtergebnis aller Kreise</div>
            {baseconfig.app.has2014Data && (
              <div className="overallresult__legend-item old">2014</div>
            )}
            <div className="overallresult__legend-turnout">
              Wahlbeteiligung: <strong>{(turnout).toString().replace(".",",")}&#8239;%</strong>
            </div>
          </div>
          <PartyBars
            items={data}
            onClick={p => this.setParty(p)}
            isClickable
            selectedParty={this.props.selectedParty}
            scaleToMax
            decimalPlaces={1}
          />
          {!isCompact && (
            <RankingListExpandButton
              isExpanded={this.state.isExpanded}
              onClick={() => this.onToggleExpand()}
            />
          )}
        </div>
        {showRanking && (
          <div
            className="overallresult__ranking"
            style={{ maxHeight: this.maxHeight }}
          >
            <RankingList
              data={data}
              onClickItem={this.props.setParty}
              selectedParty={this.props.selectedParty}
              isClickable
            />
          </div>
        )}
      </div>
    );
  }
}

export default connect(
  state => ({
    selectedParty: state.selectedParty,
    data: state.overallData,
    turnout: state.turnout
  }),
  actions
)(OverallResult);
